// Shared UI bits for the portals
import { CheckCircle2, Clock, AlertTriangle, Loader2, XCircle, FileSearch } from "lucide-react";

export const STATUS_META = {
  pending: { label: "Pending Review", color: "bg-amber-50 text-amber-800 border-amber-200", icon: Clock },
  under_review: { label: "Under Review", color: "bg-blue-50 text-blue-800 border-blue-200", icon: FileSearch },
  assigned: { label: "Caregiver Assigned", color: "bg-violet-50 text-violet-800 border-violet-200", icon: CheckCircle2 },
  in_progress: { label: "Care In Progress", color: "bg-emerald-50 text-emerald-800 border-emerald-200", icon: Loader2 },
  completed: { label: "Completed", color: "bg-slate-100 text-slate-700 border-slate-200", icon: CheckCircle2 },
  cancelled: { label: "Cancelled", color: "bg-rose-50 text-rose-800 border-rose-200", icon: XCircle },
  offered: { label: "Offered", color: "bg-[#F8F9FA] text-[#7A6A48] border-[#E5DDC9]", icon: Clock },
  accepted: { label: "Accepted", color: "bg-emerald-50 text-emerald-800 border-emerald-200", icon: CheckCircle2 },
  declined: { label: "Declined", color: "bg-rose-50 text-rose-800 border-rose-200", icon: XCircle },
};

export function StatusPill({ status, urgent }) {
  const meta = STATUS_META[status] || { label: status, color: "bg-slate-100 text-slate-700 border-slate-200", icon: Clock };
  const Icon = meta.icon;
  return (
    <div className="inline-flex items-center gap-2">
      <span
        data-testid={`status-pill-${status}`}
        className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium border ${meta.color}`}
      >
        <Icon className="w-3.5 h-3.5" /> {meta.label}
      </span>
      {urgent && (
        <span
          data-testid="urgent-badge"
          className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold bg-rose-600 text-white"
        >
          <AlertTriangle className="w-3 h-3" /> Urgent
        </span>
      )}
    </div>
  );
}

export const SERVICE_LABELS = {
  companionship: "Companionship",
  personal_care: "Personal Care",
  respite_care: "Respite Care",
  dementia_support: "Dementia Support",
  transportation: "Transportation",
  other: "Other",
};

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso;
  }
}
